import React from 'react'

export default class SeparatorMenu extends React.Component {
    render() {
       return <div className="col-1 separator">-</div>
    }
}